<div [style.background]="backgroundHexColor" [class.extra-small]="extraSmall">
    <span>{{ text }}</span>
</div>